import { render } from "./student-relationship.vue?vue&type=template&id=61e25abe&scoped=true"
import script from "./student-relationship.vue?vue&type=script&lang=js"
export * from "./student-relationship.vue?vue&type=script&lang=js"

import "./student-relationship.vue?vue&type=style&index=0&id=61e25abe&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61e25abe"]])

export default __exports__